import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect, MyStore } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Form, Row, Col, Select, Input, InputNumber, DatePicker, Button, Checkbox } from 'antd';


const css = require('./index.scss');
const FormItem = Form.Item;
const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    filterDisplay?: boolean;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class AuthConfirmFilter extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount() {
        this.props.form.setFieldsValue(this.modulesState.confirmFields || {});
    }
    render() {
        const { filterDisplay, form: { getFieldDecorator } } = this.props;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 }
        };
        let { comfirmFilter } = this.modulesState;
        const options = [
            { label: '未认证', value: 'UNCHECK' },
            { label: '已认证', value: 'PASS' },
            { label: '认证失败', value: 'FAILED' },
            { label: '认证中', value: 'CHECKING' }
        ];
        const options2 = [
            { label: '正常', value: 'NORMAL' },
            { label: '作废', value: 'CANCELLED' },
            { label: '红冲', value: 'RED' },
            { label: '异常', value: 'ABNORMAL' },
            { label: '失控', value: 'UNCONTROLLED' }
        ];
        const options3 = [
            { label: '未收票', value: 'UN_RECEIVE' },
            { label: '已收票', value: 'RECEIVED' },
        ];
        return (
            <div style={{padding:10}}>
                <Form onSubmit={this.handleFilter}>
                        <FormItem label={`开票日期`} {...formItemLayout}>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator('minInvoiceDate', {
                                        initialValue: comfirmFilter && comfirmFilter.minInvoiceDate
                                    })(
                                        <DatePicker />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={2}>
                                <span
                                    style={{
                                        display: 'inline-block',
                                        width: '100%',
                                        textAlign: 'center'
                                    }}
                                >
                                    -
                                </span>
                            </Col>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator('maxInvoiceDate', {
                                        initialValue: comfirmFilter && comfirmFilter.maxInvoiceDate
                                    })(
                                        <DatePicker />
                                    )}
                                </FormItem>
                            </Col>
                        </FormItem>
                        <FormItem label={`发票代码`} {...formItemLayout}>
                            {getFieldDecorator('invoiceCode', {
                                rules: [
                                    {
                                        message: '请输入号码（只支持数字)',
                                        pattern: /^[0-9]*$/,
                                    }
                                ],
                                initialValue: comfirmFilter && comfirmFilter.invoiceCode
                            })(
                                <Input type="text" placeholder="10位或12位发票码" maxLength={12} />
                            )}
                        </FormItem>
                        <FormItem label={`发票号码`} {...formItemLayout}>
                            {getFieldDecorator('invoiceNumber', {
                                rules: [
                                    {
                                        message: '请输入号码（只支持数字)',
                                        pattern: /^[0-9]*$/,
                                    }
                                ],
                                initialValue: comfirmFilter && comfirmFilter.invoiceNumber
                            })(
                                <Input type="text" placeholder="8位发票号码" maxLength={8} />
                            )}
                        </FormItem>
                        <FormItem label={`销方名称`} {...formItemLayout}>
                            {getFieldDecorator('fuzzySupplierName', {
                                rules: [
                                    {
                                        message: '不支持特殊字符',
                                        pattern: /^[\u4E00-\u9FA5A-Za-z0-9]+$/,
                                    }
                                ],
                                initialValue: comfirmFilter && comfirmFilter.fuzzySupplierName
                            })(
                                <Input type="text" />
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label={`认证状态`}>
                            {getFieldDecorator('authStates', {
                                initialValue: comfirmFilter && comfirmFilter.authStates
                            })(
                                <CheckboxGroup options={options} />
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label={`发票状态`}>
                            {getFieldDecorator('invoiceStates', {
                                initialValue: comfirmFilter && comfirmFilter.invoiceStates
                            })(
                                <CheckboxGroup options={options2} />
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label={`收票状态`}>
                            {getFieldDecorator('loggingStates', {
                                initialValue: comfirmFilter && comfirmFilter.loggingStates
                            })(
                                <CheckboxGroup options={options3} />
                            )}
                        </FormItem>
                        <div className="text-right">
                            <Button
                                onClick={this.handleReset}
                                className="mr10"
                            >
                                清空
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                            >
                                筛选
                            </Button>
                        </div>
                </Form>
            </div>
        );
    }
    private handleFilter = (e) => {
        const { user } = MyStore.instance.getState();
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            ModulesAction.handleConfirmFilter(values);
            ModulesAction.updateConfirm(values, 1);
        });
    }

    private handleReset = () => {
        this.props.form.resetFields();
        this.modulesState.comfirmFilter = null;
        this.modulesState.confirmFields = null;
        ModulesAction.setModulesState();
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/UI.AuthConfirm.Filter.tsx